export const FHW_SEARCH_DATA_ID = 'react-data-fhw-search'
export const PARTNER_ANCHOR_PREFIX = 'partnerId:'